import { createAction } from 'redux-actions';

export const moduleName = 'matrix';

export const MATRIX_DETAIL_SELECT = `${moduleName}/MATRIX_DETAIL_SELECT`;

export const switchDetail = createAction(
  MATRIX_DETAIL_SELECT,
  payload => payload,
  () => ({ selfClosing: true }),
);
